import { render, staticRenderFns } from "./split.vue?vue&type=template&id=7395898e&scoped=true"
import script from "./split.vue?vue&type=script&lang=js"
export * from "./split.vue?vue&type=script&lang=js"
import style0 from "./split.vue?vue&type=style&index=0&id=7395898e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7395898e",
  null
  
)

export default component.exports